import { ListItemIcon, ListItemText, MenuItem, SvgIconTypeMap, SxProps, Theme } from '@mui/material'
import { OverridableComponent } from '@mui/material/OverridableComponent'

// Shared look of the side menu rows: spaced uppercase labels, a purple icon and
// underline on the page currently open. Larger on phones, more compact on desktop.
export const menuItemSx: SxProps<Theme> = {
  py: { xs: 1.25, md: 0.75 },
  px: 3,
}

export const menuIconSx = (active?: boolean): SxProps<Theme> => ({
  minWidth: '2rem !important',
  color: active ? 'secondary.main' : 'grey.100',
})

export const menuTextSx = (active?: boolean): SxProps<Theme> => ({
  display: 'inline-block',
  textTransform: 'uppercase',
  letterSpacing: { xs: '0.12em', md: '0.1em' },
  fontSize: { xs: '1rem', md: '0.875rem' },
  fontWeight: 400,
  lineHeight: 1.6,
  color: 'grey.100',
  borderBottom: '2px solid',
  borderColor: active ? 'secondary.main' : 'transparent',
})

export interface SideMenuIconProps {
  title: string
  url: string
  'data-cy': string
  icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>
  handleNavigate: (url: string) => void
  disabled?: boolean
  active?: boolean
}

export function SideMenuIcon(props: SideMenuIconProps): React.ReactElement {
  const { title, url, handleNavigate, disabled, active } = props
  const Icon = props.icon

  return (
    <MenuItem
      data-cy={props['data-cy']}
      onClick={() => !disabled && handleNavigate(url)}
      disabled={disabled}
      aria-current={active ? 'page' : undefined}
      sx={menuItemSx}
    >
      <ListItemIcon sx={menuIconSx(active)}>
        <Icon fontSize="small" />
      </ListItemIcon>
      <ListItemText primaryTypographyProps={{ sx: menuTextSx(active) }}>{title}</ListItemText>
    </MenuItem>
  )
}
